module.exports = __webpack_public_path__ + "img/bg-one.9eb7aecb.jpg";